<template>
    <inventories-find
        :inventory="$route.params.inventory"
        :include="['files(paginate:1,6)']"
    >
        <div
            slot-scope="{
                data: inventory,
                error,
                is_loading,
                has_loaded,
                find
            }"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <base-alert
                    v-if="inventory.archived_at"
                    level="warning"
                    class="mb-6"
                >
                    <template slot="heading">Inventory Archived</template>
                    <template slot="content">
                        <p>This inventory was archived on {{ inventory.archived_at | moment('D MMM, YYYY') }}.</p>
                    </template>
                </base-alert>

                <details-card class="mb-6">
                    <template slot="header">
                        <div class="flex-grow overflow-hidden mr-3">
                            <h1 class="text-lg font-normal truncate">
                                {{ inventory.title }}
                            </h1>
                        </div>

                        <div
                            v-if="inventory.can.update"
                            class="flex-none w-6 h-6"
                        >
                            <base-dropdown
                                placement="bottom-end"
                                class="w-full h-full"
                            >
                                <button
                                    slot="trigger"
                                    slot-scope="{ is_open, toggle }"
                                    :class="{ 'shadow-outline': is_open }"
                                    class="btn btn-none w-full h-full"
                                    type="button"
                                    @click.prevent="toggle"
                                >
                                    <base-svg
                                        name="icon-dots-horizontal"
                                        class="h-6 w-6"
                                    />
                                </button>

                                <div
                                    slot="menu"
                                    slot-scope="{ }"
                                    class="dropdown-menu w-64"
                                >
                                    <router-link
                                        :to="{
                                            name: $router.fix('dashboard.*.inventories.edit'),
                                            params: {
                                                inventory: inventory.uuid
                                            }
                                        }"
                                        class="dropdown-menu-link"
                                    >
                                        Edit
                                    </router-link>
                                </div>
                            </base-dropdown>
                        </div>
                    </template>

                    <template slot="body">
                        <grid-layout>
                            <grid-layout-item class="mb-3">
                                <div class="text-label text-xs">Description</div>
                                <div class="text-sm">{{ inventory.description || 'n/a' }}</div>
                            </grid-layout-item>
                        </grid-layout>
                    </template>
                </details-card>

                <div class="bg-grey-bg rounded shadow">
                    <header class="flex items-center bg-white rounded-t border-b h-16 px-4 sm:px-6">
                        <h3 class="text-base font-normal">Files</h3>
                    </header>

                    <files-list :files="inventory.files.data" />

                    <div
                        v-if="inventory.files.meta.total === 0"
                        class="p-3 text-center text-grey italic"
                    >
                        There's nothing here!
                    </div>

                    <div
                        v-if="inventory.files.meta.last_page > inventory.files.meta.page"
                        class="bg-grey-bg text-grey-darker text-sm font-semibold px-4 pt-3 pb-2 sm:px-6"
                    >
                        <base-more
                            :to="{
                                name: $router.fix('dashboard.*.inventories.files.index'),
                                params: {
                                    inventory: inventory.uuid
                                }
                            }"
                            :count="inventory.files.meta.count"
                            :total="inventory.files.meta.total"
                        />
                    </div>
                </div>
            </template>
        </div>
    </inventories-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import InventoriesFind from '../../../../components/inventories-find'
    import FilesList from '../../../../components/files-list'

    export default {
        components: {
            DetailsCard,
            InventoriesFind,
            FilesList
        }
    }
</script>
